export const teamConstants = {
    LIST_REQUEST: 'TEAMS_LIST_REQUEST',
    LIST_SUCCESS: 'TEAMS_LIST_SUCCESS',
    LIST_FAILURE: 'TEAMS_LIST_FAILURE',
    CREATE_REQUEST: 'CREATE_REQUEST',
    CREATE_SUCCESS: 'CREATE_SUCCESS',
    CREATE_FAILURE: 'CREATE_FAILURE',
    REMOVE_REQUEST: 'REMOVE_REQUEST',
    REMOVE_SUCCESS: 'REMOVE_SUCCESS',
    REMOVE_FAILURE: 'REMOVE_FAILURE',
    UPLOAD_LOGO_REQUEST: 'TEAM_UPLOAD_LOGO_REQUEST',
    UPLOAD_LOGO_SUCCESS: 'TEAM_UPLOAD_LOGO_SUCCESS',
    UPLOAD_LOGO_FAILURE: 'TEAM_UPLOAD_LOGO_FAILURE',
}
